import styles from './Alumni.module.css'

const CircleIndividual = () => {
    return ( 
        <div className= {styles.circleindividual}>
        </div>
     );
}
 
export default CircleIndividual;